<template>
    <div class="wrapper">
        <div class="top">
            <img src="../assets/img_bg.png" alt="" class="top_bg">
            <div class="btn_wrap">
                <!-- <div class="btn android" id="android"></div>
                <div class="btn ios" id="ios">
                    <img src=../assets/xioabandian.png" alt="" class="qr_code" id="qrCode" style="display: none;">
                </div> -->
            </div>
        </div>
        <div class="bottom">
            <!-- <img id="bottomBg1" src=../assets/bottom_bg_1.png" alt="" class="bottom_bg">
            <img id="bottomBg2" src=../assets/bottom_bg_2.png" alt="" class="bottom_bg"> -->
            <div class="content_warp">
                <div class="content_box">
                    <div class="content fl left_content">
                        <p class="title">产品介绍</p>
                        <p class="content_text">
                            MOMI是时下备受年轻人欢迎的语音交友平台！高清音质，稳定不卡，给你飞速般的畅快体验。<br>
                            这里为大家带来了更加有趣的语音社交模式，让聊天更加直接高效。 <br>
                            为大家带来了更热门的聊天话题，拒绝各种尬聊。<br>
                            打造个人人气模式，让你尽情展现你的魅力。<br>
                        </p>
                    </div>
                    <div class="content fl right_content">
                        <p class="title">公司介绍</p>
                        <p class="content_text">
                            MOMI是与乐科技有限公司的首个语音交友APP软件，支持多方实时语音聊天，受到广大年轻人的热捧！MOMI语音社交，用声音塑造你我的缘分
                        </p>
                        <!-- <p class="privacy"><a href="./privacy_dx.html">隐私政策 <img src=../assets/arrow.png" alt="" class="arrow"></a></p> -->
                    </div>
                </div>
                <div class="copy_box">
                    <!-- <p class="copy_content">
                        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">琼ICP备19003506号-1</a>
                    </p> -->
                    <!-- <p class="copy_content">
                        <a :href="url_+'/dist/assets/img/card2.jpg'" target="_blank"> 增值电信业务经营许可证 琼B2-20190517</a>
                    </p> -->
                    <!-- <p class="copy_content">与乐科技有限公司 </p> -->
                    <!-- <p class="copy_content"> 联系方式<span class="seperate"></span> </p> -->
                    <!-- <p class="copy_content">Copyright © 2019-2021 ALL Rights Reserved</p> -->
                    <p class="copy_content">与乐科技有限公司 </p>
                    <p class="copy_content"> 联系方式<span class="seperate">Email：hkyolo2022@163.com</span> </p>
                    <p class="copy_content">Copyright © YOLO TECHNOLOGY LIMITED</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { setTimeout, setInterval, clearInterval } from "timers";
export default {
  name: "index",
  components: {},
  props: {},
  data() {
    return {
      ew: {
        two: false,
        three: false
      }
    };
  },
  watch: {},
  computed: {
      url_() {
        return this.$store.state.user.url;
    },
  },
  methods: {
    qrcode() {},
    Login() {
      let that = this;
      clearInterval(that.timeO);
    }
  },
  created() {
    if (location.href.indexOf("http://127.0.0.1:8080") < 0) {
      // location.href='http://127.0.0.1:8080';
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.home,.about{
            width: 100%;
            padding-top: 5.365vw;
            transition: all ease .5s;
        }

        .top,.middle,.bottom{
            width: 100%;
            position: relative;
        }

        .top_bg{
            display: block;
            width: 100%;
            height: auto;
            /* margin-top: -1px; */
        }

        .title_img{
            position: absolute;
            top: 13.8vw;
            left: 7.4vw;
            width: 30.5vw;
            height: 12.1vw;
        }

        .btn_wrap{
            position: absolute;
            top:17.8vw;
            left: 17.4vw;
            width: 60.5vw;
            height: 3.96vw;
            z-index: 11;
        }

        .btn{
            display: inline-block;
            width: 13.26vw;
            height: 3.96vw;
            margin-right: 2.6vw;
            cursor: pointer;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: top center;
            position: relative;
        }

        .android{
            background-image: url('../assets/android@2x.png');
        }
        /* .dd_android{
            background-image: url('./imgs/dd_Android.png');
        } */
        .ios{
            background-image: url('../assets/apple@2x.png');
        }
        /* .dd_ios{
            background-image: url('./imgs/dd_apple.png');
        } */
        .ios .qr_code{
            position: absolute;
            left: 50%;
            margin-left: -50px;
            top: 110%;
            width: 100px;
            height: 100px;
            background: red;
        }

        .middle:after,.content_box:after{
            content: '';
            display: block;
            height: 0;
            clear: both;
        }

        .block{
            width: 50%;
            height: 48vw;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .fl{
            float: left;
        }
        .fr{
            float: right;
        }
        .pic{
            display: block;
            width: 100%;
            height: auto;
        }
        .desc{
            display: block;
            width: 39vw;
            height: auto;
        }

        .bottom{
            position: relative;
            z-index: 11;
        }

        .bottom_bg{
            display: block;
            width: 100%;
            height: auto;
        }

        .content_warp{
            position: absolute;
            top: 0;
            left: 0;
            padding-top: 5vw;
            width: 100%;
            height: 100%;
        }

        .content_box{
            width: 70vw;
            margin: 0 auto 3.12vw;
        }

        .content{
            width: 49.5%;
            color: #B671FF;
        }

        .left_content{
            padding-right: 3.9vw;
            border-right: 1px solid #B671FF;
        }

        .right_content{
            padding-left: 3.9vw;
        }

        .title{
            font: 500 1.46vw/1.6vw PingFangSC-Medium, PingFang SC;
            margin-bottom: 1.14vw;
        }

        .content_text{
            font: 400 1.04vw/1.34vw PingFangSC-Regular, PingFang SC;
        }

        .copy_box{
            width: 70vw;
            margin: 0 auto 2vw;
        }

        .copy_content{
            width: 100%;
            font: 400 1.04vw/1.78vw PingFangSC-Regular, PingFang SC;
            text-align: center;
            color: #B671FF;
        }

        .seperate{
            margin-left: 1.04vw;
        }

        .privacy{
            font: 500 1.46vw/1.6vw PingFangSC-Medium, PingFang SC;
            margin-top: 1.66vw;
        }

        .arrow{
            display: inline-block;
            width: 1.25vw;
            height: 1.146vw;
        }

        a{
            color: #B671FF;
            cursor: pointer;
            text-decoration: none;
        }
        a:hover{
            text-decoration: underline;
        }
</style>



// WEBPACK FOOTER //
// src/views/index.vue